var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { loading } from 'elements/Loading';
import theme from 'Theme';
import IconosApp, { Icono } from 'elements/IconosApp';
import cxs from 'cxs/component';
import Theme from '../../../Theme';
import History from '../../../helpers/History';
import Packet from '../../Packets/Packet';
import Stretch from '../../Stretches/Stretch';
import CollaboratorStretch from '../../CollaboratorStretches/CollaboratorStretch';
import { Button, Hairline, View } from '../../../elements';
import { T } from 'helpers/i18n';
import { TypeTicket } from '../../Detail/DetailRoutes';
import { SearchInput } from '../../../components';
let ListAll = class ListAll extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            typeSaleSelected: null,
            searchTerm: null,
        };
        this.handleSelectItem = (value) => {
            if (value instanceof CollaboratorStretch) {
                history.push(`/detail/cs/${value.id}/${value.operator_id}`);
            }
            else if (value instanceof Stretch) {
                history.push(`/detail/stretches/${value.id}`);
            }
            else if (value instanceof Packet) {
                const packet = this.props.store.packetsStore.data.find((item) => item.id === value.id);
                console.log('packet - operationLineName: ', packet.operationLine.name);
                history.push(`/detail/packets/${value.id}`);
            }
        };
        this.handleSelectTypeSale = (typeSaleSelected) => {
            if (this.state.typeSaleSelected === typeSaleSelected) {
                this.setState({ typeSaleSelected: null });
                return;
            }
            this.setState({ typeSaleSelected });
        };
    }
    componentDidMount() {
        const hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        // console.log('StretchesList - componentDidMount - hasParent', hasParent)
        this.props.store.UI.changeHasParent(hasParent);
    }
    render() {
        const { stretchesStore, packetsStore, collaboratorStretchesStore } = this.props.store;
        const { operationLines } = this.props.store;
        const { typeSaleSelected } = this.state;
        const dataStretches = !typeSaleSelected || typeSaleSelected === TypeTicket.Stretch
            ? stretchesStore.data
            : [];
        const dataCollaboratorsStretches = !typeSaleSelected || typeSaleSelected === TypeTicket.CollaboratorStretch
            ? collaboratorStretchesStore.services
            : [];
        const dataPackets = !typeSaleSelected || typeSaleSelected === TypeTicket.Packet
            ? packetsStore.data
            : [];
        let mapeados = [
            ...dataCollaboratorsStretches,
            ...dataStretches,
            ...dataPackets,
        ];
        if (this.state.searchTerm) {
            mapeados = mapeados.filter((value) => value.name.toLowerCase().includes(this.state.searchTerm.toLowerCase()));
        }
        if (!(operationLines.data.length > 0))
            return (React.createElement("div", null,
                React.createElement("text", null, "No hay lineas de operaci\u00F3n, por favor cree una antes")));
        return (React.createElement("div", { style: {
                display: 'block',
                justifyContent: 'center',
                paddingLeft: '10px',
                paddingRight: '10px',
            } },
            React.createElement(SearchInput, { onChange: (value) => {
                    this.setState({ searchTerm: value });
                } }),
            React.createElement(View, { flex: true, row: true },
                React.createElement(View, null,
                    React.createElement(WrapperButton, { selected: this.state.typeSaleSelected === TypeTicket.Stretch, onClick: () => this.handleSelectTypeSale(TypeTicket.Stretch) }, T('services'))),
                React.createElement(View, null,
                    React.createElement(WrapperButton, { selected: this.state.typeSaleSelected === TypeTicket.Packet, onClick: () => this.handleSelectTypeSale(TypeTicket.Packet) }, T('packets'))),
                React.createElement(View, null,
                    React.createElement(WrapperButton, { selected: this.state.typeSaleSelected === TypeTicket.CollaboratorStretch, onClick: () => this.handleSelectTypeSale(TypeTicket.CollaboratorStretch) }, T('collaboratorsType'))),
                React.createElement(Hairline, { vertical: true })),
            React.createElement(Hairline, { style: { margin: 0 }, horizontal: true }),
            mapeados.map((item, index) => {
                var _a;
                return (React.createElement(WrapperItem, { key: `${item.name}_${item.id}`, onClick: () => this.handleSelectItem(item) },
                    !item.image && (React.createElement(IconosApp, { style: {
                            fontSize: '50px',
                        }, name: Icono[item.icon] })),
                    item.image && (React.createElement("img", { src: item.image, alt: `imagen ${item.name}`, style: {
                            height: '50px',
                        } })),
                    React.createElement(StyleDiv, null,
                        React.createElement(StyledOperation, null, ((_a = item.operationLine) === null || _a === void 0 ? void 0 : _a.name) || ''),
                        React.createElement(StyledP, null, item.name))));
            })));
    }
};
ListAll = __decorate([
    inject('store'),
    loading((props) => {
        return [props.store.structureStore.getStructure(props.store)];
    }),
    observer
], ListAll);
export default ListAll;
const WrapperButton = cxs(Button)(({ selected }) => ({
    color: selected ? theme.color.primary : null,
}));
const WrapperItem = cxs('div')({
    borderBottom: `1px solid ${theme.color.hairline}`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    /*margin: '30px',*/
    height: '90px',
    ':hover': {
        color: Theme.color.primary,
    },
});
const StyleDiv = cxs('div')({
    textAlign: 'left',
    display: 'inline',
    paddingLeft: '10px',
});
const StyledOperation = cxs('p')({
    marginBottom: 0,
    fontWeight: 'bold',
});
const StyledP = cxs('p')({
    marginBottom: 0,
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Structures/container/ListAll.tsx
// module id = 584
// module chunks = 0